'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactKonva = require('react-konva');

var _md = require('md5');

var _md2 = _interopRequireDefault(_md);

var _ScaledRect = require('./ScaledRect');

var _ScaledRect2 = _interopRequireDefault(_ScaledRect);

var _hero = require('./data/hero1');

var _hero2 = _interopRequireDefault(_hero);

var _hero3 = require('./data/hero2');

var _hero4 = _interopRequireDefault(_hero3);

var _hero5 = require('./data/hero3');

var _hero6 = _interopRequireDefault(_hero5);

var _hero7 = require('./data/hero4');

var _hero8 = _interopRequireDefault(_hero7);

var _colors = require('./data/colors');

var _colors2 = _interopRequireDefault(_colors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SIDE_LENGTH = 16;
var NUMBER_BASE = 16; // hex
var HERO_STEP_SIZE = 4;

var HashHero = function (_React$PureComponent) {
    _inherits(HashHero, _React$PureComponent);

    function HashHero() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, HashHero);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = HashHero.__proto__ || Object.getPrototypeOf(HashHero)).call.apply(_ref, [this].concat(args))), _this), _this.draw = function (characterObj, colorSet) {
            var allRects = [];
            var keys = Object.keys(characterObj);

            keys.forEach(function (key) {
                var shapes = characterObj[key];
                shapes.forEach(function (shapeObj) {
                    allRects.push(_react2.default.createElement(_ScaledRect2.default, {
                        scalingFactor: _this.props.scalingFactor,
                        x: shapeObj.x,
                        y: shapeObj.y,
                        height: shapeObj.height,
                        width: shapeObj.width,
                        fill: colorSet[key] }));
                });
            });
            return allRects;
        }, _this.getCharacter = function (hex) {
            var num = Number.parseInt(hex, NUMBER_BASE);
            var heroOptions = [_hero2.default, _hero4.default, _hero6.default, _hero8.default];
            return heroOptions[Math.floor(num / HERO_STEP_SIZE)];
        }, _this.getColors = function (seed) {
            var charColors = {};
            var keys = Object.keys(_hero2.default);

            keys.forEach(function (key, i) {
                var num = Number.parseInt(seed[seed.length - i - 2], NUMBER_BASE);
                charColors[key] = _colors2.default[key][num];
            });
            return charColors;
        }, _this.isAddress = function (seed) {
            if (!/^(0x)?[0-9a-f]{40}$/i.test(seed)) {
                // check if it has the basic requirements of an address
                return false;
            }
            return true;
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    /**
     * From https://github.com/ethereum/go-ethereum/blob/aa9fff3e68b1def0a9a22009c233150bf9ba481f/jsre/ethereum_js.go
     * Checks if the given string is an address
     *
     * @method isAddress
     * @param {String} address the given HEX adress
     * @return {Boolean}
    */


    _createClass(HashHero, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                seed = _props.seed,
                scalingFactor = _props.scalingFactor;

            if (!this.isAddress(seed)) {
                return null;
            }

            // todo: potential performance issue with this in render. maybe set in state?
            var hashedSeed = (0, _md2.default)(seed);
            var firstChar = hashedSeed[hashedSeed.length - 1];
            var charColors = this.getColors(hashedSeed);
            var allRects = this.draw(this.getCharacter(firstChar), charColors);

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    _reactKonva.Stage,
                    { width: SIDE_LENGTH * scalingFactor, height: SIDE_LENGTH * scalingFactor },
                    _react2.default.createElement(
                        _reactKonva.Layer,
                        null,
                        allRects
                    )
                )
            );
        }
    }]);

    return HashHero;
}(_react2.default.PureComponent);

exports.default = HashHero;


HashHero.propTypes = {
    seed: _propTypes2.default.string.isRequired
};

HashHero.defaultProps = {
    scalingFactor: 5
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/hash-heroes/lib/HashHero.js
// module id = 341
// module chunks = 0